import { cn } from '@/lib/utils'
import type { UserRole } from '@/types/database'
import { TISACard } from '@/components/tisa/TISACard'
import { StudentNav } from '@/components/navigation/StudentNav'
import { TeacherNav } from '@/components/navigation/TeacherNav'

interface RoleLayoutProps {
  children: React.ReactNode
  role: UserRole
}

function RoleLayout({ children, role }: RoleLayoutProps) {
  return (
    <div className={cn(
      "min-h-screen bg-background",
      `role-${role}` // This applies role-specific CSS custom properties
    )}>
      {/* Add navigation based on role */}
      {role === 'student' && <StudentNav />}
      {role === 'teacher' && <TeacherNav />}

      <main id="main-content" className="container mx-auto px-4 py-6">
        {children}
      </main>
    </div>
  )
}

// Import the login form
import { LoginForm } from '@/components/auth/LoginForm'

function LoginPage() {
  return <LoginForm />
}

// Import the real dashboard
import { StudentDashboard as RealStudentDashboard } from '@/components/dashboard/StudentDashboard'

function StudentDashboard() {
  return <RealStudentDashboard />
}

function TeacherDashboard() {
  return (
    <div className="space-y-6">
      <h1 className="text-child-3xl font-bold text-primary">
        Teacher Dashboard
      </h1>
      <TISACard>
        <p>Class management features will be implemented here</p>
      </TISACard>
    </div>
  )
}

function LibrarianDashboard() {
  return (
    <div className="space-y-6">
      <h1 className="text-child-3xl font-bold text-primary">
        Librarian Dashboard
      </h1>
      <TISACard>
        <p>Library management features will be implemented here</p>
      </TISACard>
    </div>
  )
}

function ParentDashboard() {
  return (
    <div className="space-y-6">
      <h1 className="text-child-3xl font-bold text-primary">
        Parent Dashboard
      </h1>
      <TISACard>
        <p>Child progress monitoring will be implemented here</p>
      </TISACard>
    </div>
  )
}

import { BookSearch as RealBookSearch } from '@/components/books/BookSearch'

function BookSearch() {
  return <RealBookSearch />
}

import { BookDetails as RealBookDetails } from '@/components/books/BookDetails'

function BookDetails() {
  return <RealBookDetails />
}

export default RoleLayout
export {
  LoginPage,
  StudentDashboard,
  TeacherDashboard,
  LibrarianDashboard,
  ParentDashboard,
  BookSearch,
  BookDetails
}